import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';
import Vue from 'vue';


export default {
  namespaced: true,
  state: {
    currentUserRoles: [],
  },
  mutations: {
    setRoles(state: any, payload: boolean): void {
      Vue.set(state, 'currentUserRoles', payload);
    },
  },
  getters: {
    currentUserRoles: (state: any): boolean => state.currentUserRoles,
    roleUser: (state: any): boolean => state.currentUserRoles.some((r: string) => r === 'User'),
    roleManager: (state: any): boolean => state.currentUserRoles.some((r: string) => r === 'Manager'),
    roleAdmin: (state: any): boolean => state.currentUserRoles.some((r: string) => r === 'Admin'),
  },
};

